import React from 'react';
import { getIcon } from '../shared/field_inputs/shared/FormatHelpers';

const GlobalSearchDropdown = ({
    suggestions,
    debouncedInput,
    setActiveIndex,
    onMouseDown,
    disableScroll,
    maxSuggestionsToShow,
    categories,
    category,
    setCategory,
    isLoading,
    activeIndex,
}) => {
    const scrollStyle = disableScroll ? null : { maxHeight: '400px', overflowY: 'scroll' };

    let suggestionList;
    const filteredSuggestions = maxSuggestionsToShow && suggestions ? suggestions.slice(0, maxSuggestionsToShow) : suggestions || [];
    if (filteredSuggestions && filteredSuggestions.length) {
        suggestionList = filteredSuggestions.map((item, index) => {
            const isFile = item.category === 4;
            const icon = categories.find((category) => category.index === item.category).icon;

            var anchorParts = (item.itemLink || '').split('file-');
            let fileId;
            if (isFile && anchorParts.length > 1) {
                fileId = anchorParts[1];
            }
            return (
                <div
                    id={`suggestion-${index}`}
                    key={item.id ? item.id : index}
                    onMouseOver={() => setActiveIndex(index)}
                    className={`suggestion-item ${index === activeIndex ? ' suggestion-item-active' : ''}`}>
                    <div onMouseDown={onMouseDown}>
                        <span>{getIcon(icon)}</span>
                        <span className={'suggestion-text'}>
                            {item.title}

                            {item.subtitle ? (
                                <span>
                                    <br />
                                    <span className={'suggestion-subtitle'}>{item.subtitle}</span>
                                </span>
                            ) : null}
                        </span>
                    </div>

                    {isFile && fileId ? (
                        <div className='ml-auto'>
                            {/* Saknar item.id */}
                            <a
                                className='download-file btn btn-outline-secondary border-0 dropdown mr-auto'
                                href={`api/crmFileFront/${fileId}/download`}>
                                <i className='download-file-icon oi oi-data-transfer-download'></i>
                            </a>
                        </div>
                    ) : null}
                </div>
            );
        });
    } else if (!isLoading) {
        suggestionList = (
            <div className={'no-results'}>
                Inga sökträffar {category.index != null ? `i ${category.name}` : null} på "{debouncedInput}"
            </div>
        );
    } else {
        suggestionList = null;
    }

    return (
        <div className={'global-dropdown'}>
            <div className={'categories'}>
                {categories.map((cat) => (
                    <CategorySelector category={cat} currentCategory={category} setCategory={setCategory} key={cat.name} />
                ))}
            </div>
            <div className={'suggestions'} id={'suggestions'} style={scrollStyle}>
                {suggestionList}
            </div>
        </div>
    );
};

export default GlobalSearchDropdown;

const CategorySelector = ({ category, currentCategory, setCategory }) => {
    const icon = getIcon(category.icon);

    const setNewCategory = (category) => {
        if (category.index != currentCategory.index) {
            setCategory(category);
        }
    };

    return (
        <div
            className={`category-item ${currentCategory.index === category.index ? ' category-item-selected' : null}`}
            onClick={() => setNewCategory(category)}>
            {icon}
            &nbsp;{category.name}
        </div>
    );
};
